import { defineStore } from "pinia";
import axios from "@/services/AxiosBase";
import { useSettingStore } from "./settings";
import _ from "lodash";
import { useResourceStore } from "./resources";
import customParseFormat from "dayjs/plugin/customParseFormat";
import dayjs from "dayjs";
import Cookies from "js-cookie";
dayjs.extend(customParseFormat);

export const useUserStore = defineStore({
  id: "userStore",
  state: () => ({
    user: {},
  }),
  getters: {
    getUser: (state) => state.user,
    language: (state) => {
      const { getLanguageByLocale } = useSettingStore();
      const language = getLanguageByLocale(state.user.locale);
      return language;
    },
    history: (state) => {
      const { getResourceById } = useResourceStore();
      let historial = state.user?.acf.historial;
      if (historial) {
        historial.forEach((element) => {
          if (element.recurso.ID)
            element.recurso = getResourceById(element.recurso.ID);
          return element;
        });

        historial.sort((a, b) => {
          let aDate = dayjs(a.fecha, "YYYY-MM-DD H:mm:ss");
          let bDate = dayjs(b.fecha, "YYYY-MM-DD H:mm:ss");
          return aDate > bDate ? -1 : aDate < bDate ? 1 : 0;
        });
      }
      return historial;
    },
    isPress: (state) => state.user.roles === "press",
    shouldShowTour: (state) => {
      return state.user?.is_first_login === true;
    },
  },
  actions: {
    async init() {
      //this.updateLanguage();
      try {
        const result = await axios.get(`/users/me`, {
          params: {
            acf_format: "standard",
            context: "edit",
            _fields:
              "first_name,last_name,acf,locale,roles,company,country,email,is_first_login,login_amount",
          },
        });
        this.user = result.data;
        this.updateFields();
      } catch (error) {
        console.error(error);
      }
      //this.updateLanguage();
    },
    commit() {
      let data = _.omit(this.user, ["_links"]);
      data.acf = _.omit(data.acf, ["historial", "seleccion", "last_mod"]);
      data.user_roles = data.roles;
      if (data.country === "ESP") {
        data.acf = _.omit(data.acf, ["CAN_state", "USA_state"]);
      }
      if (data.country === "USA") {
        data.acf = _.omit(data.acf, ["CAN_state", "ESP_state"]);
      }
      if (data.country === "CAN") {
        data.acf = _.omit(data.acf, ["ESP_state", "USA_state"]);
      }
      if (!["USA", "ESP", "CAN"].includes(data.country)) {
        data.acf = _.omit(data.acf, ["ESP_state", "USA_state", "CAN_state"]);
      }
      const result = axios.post(`/users/me`, data, {
        params: { acf_format: "standard", context: "edit" },
      });
      result.then((response) => {
        this.user = response.data;
        this.updateFields();
        this.updateLanguage();
        setTimeout(() => this.$router.go(), 2000);
      });
      return result;
    },
    updateLanguage() {
      const language = this.user.locale.split("_")[0];

      const options = location.hostname.endsWith("viccarbe.com")
        ? { domain: ".viccarbe.com" }
        : {};

      Cookies.set("ap-change-language", true, options);
      Cookies.set("area-profesionales-idioma", language, options);

      this.$i18n.global.locale.value = language;
    },
    updateFields() {
      this.user.roles = this.user.roles[0];
      this.user.country = this.user.country.iso;
    },
    async markTourAsShown() {
      this.user.is_first_login = false;
      
      try {
        const result = await axios.post(`/users/me`, {
          meta: {
            is_first_login: false
          }
        }, {
          params: { 
            acf_format: "standard", 
            context: "edit" 
          },
        });
                
        if (result.data) {
          this.user = { ...this.user, ...result.data };
        }
      } catch (error) {
        console.error('Error updating first login status:', error);
        this.user.is_first_login = true;
      }
    },
  },
  persist: {
    enabled: true,
  },
});
